import { config } from "@/config";

/**
 * Files CDN origin, mirroring canvas-view's `shareBaseUrl` precedence:
 * the files host, then the share host, then this origin.
 */
function publicAssetOrigin(): string {
  return (
    config.hosts.file ||
    config.hosts.share ||
    window.location.origin
  ).replace(/\/$/, "");
}

/** Public, unsigned 1200x630 og image for a published canvas — plain `<img>`, no auth. */
export function buildTemplateOgImageUrl(canvasId: string): string {
  return `${publicAssetOrigin()}/public/canvases/${encodeURIComponent(canvasId)}/og.png`;
}

/** Public file viewer shell (`/view/public/{id}`), the file-view entry point. */
export function buildPublicFileUrl(fileId: string): string {
  return `${publicAssetOrigin()}/view/public/${encodeURIComponent(fileId)}`;
}
